import React from 'react'
import axios from 'axios'
import ConfigAPI from '../../constant/ConfigAPI'
import useMapStore from '../../stores/useMapStore'
import useLoadingStore from '../../stores/useLoadingStore'
import { useTranslation } from 'react-i18next'

type useMapUpperBarType = {
    showDialog: (message: string) => void
    drawStationFromSearchKeyword?: (lon: number, lat: number, data: SearchResultType) => void
}
const useMapUpperBar = (props: useMapUpperBarType) => {
    const {showDialog, drawStationFromSearchKeyword} = props
    const mapStore = useMapStore()
    const loadingStore = useLoadingStore()
    const { t } = useTranslation()

    const callServiceSearchAdministrativeAutocomplete = async (value: string) => {
        try {
            const url = `${process.env.REACT_APP_API}/api/antenna/search/administrative/autocomplete?keyword=${encodeURI(value)}`
            const result = await axios.get(url, ConfigAPI)
            return result.data as AdministrativeType[]
        } catch (error) { }
    }

    const callServiceSearchAdministrative = async (adminLevel: string, adminId: number) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/antenna/search/administrative?admin_level=${adminLevel}&admin_id=${adminId}`
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                drawStationFromSearchKeyword?.(
                    result.data.reception.longitude,
                    result.data.reception.latitude,
                    result.data,
                )
                mapStore.setMapUpperBar(false)
            }
            return result.data
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                if (errMsg.includes('404')) {
                    showDialog(t('ALERT.CONTENT.STATION_NOT_FOUND_KEYWORD'))
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    return {
        callServiceSearchAdministrativeAutocomplete,
        callServiceSearchAdministrative
    }
}

export default useMapUpperBar